export default __webpack_public_path__ + "img/motif.38ac0531.jpg";